import React from 'react';

import ExternalPageModal from './ExternalPageModal';

export default function CreditsExternalPageModal() {
  return <ExternalPageModal message="Use Stripe to manage your credits plan." />;
}
